// extracted by mini-css-extract-plugin
module.exports = {"header":"_8a9813f","button":"_b1bdd28","tickIcon":"_b839413","closeIcon":"_28e1842"};